import { render, staticRenderFns } from "./样板.vue?vue&type=template&id=53c6a0e0&scoped=true"
import script from "./样板.vue?vue&type=script&lang=js"
export * from "./样板.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c6a0e0",
  null
  
)

export default component.exports